import Vue from 'vue';
import {handleErrors} from "@/services/ErrorHandling";

const self = Vue.prototype;

export default {

  countUnpaidInvoices(from, to) {
    return new Promise((resolve, reject) => {
      const url = `${self.$apiRouter.countUnpaidInvoices}/${from}/${to}`;
      self.axios.get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  listUnpaidInvoices(date, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      const url = `${self.$apiRouter.listUnpaidInvoices}/${date}?page=${page}&per_page=${perPage}`;
      self.axios.get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getFilteredInvoices(query, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminInvoice + `?page=${page}&per_page=${perPage}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  getInvoice(id, query) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminInvoice + `/${id}?${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getPdfForPayment(id, query) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminInvoice + `/pdf/${id}?${query}`, {}, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  sendInvoice(id) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminInvoice + `/send/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  voidInvoice(id) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminInvoice + `/void/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delete(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.adminInvoice + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  payByAuthorize(id, options, card) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminPayByAuthorize + id, {
        options: options,
        credit_card: card
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  payByPayPal(id, body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminPayByPayPal + id, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  payByPoints(id, body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminPayByPoints + id, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  initToSave(orderId) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminInvoice + `/init/${orderId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getInvoiceForUpdate(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminInvoice + `/update/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  addManualInvoice(body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminInvoice, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  saveManualInvoice(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminInvoice + '/update', body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getTypesMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminInvoice + '/types-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  }
}
